import React, { useContext, useEffect, useState } from "react";
import AuthContext from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import {
  TextField,
  Typography,
  Button,
  IconButton,
  InputAdornment,
} from "@mui/material";
import { Visibility, VisibilityOff, ArrowForward, ShieldOutlined } from "@mui/icons-material";

const LoginPage = () => {
  let { loginUser } = useContext(AuthContext);
  let { authToken } = useContext(AuthContext);

  const [showPassword, setShowPassword] = useState(false);
  let navigate = useNavigate();

  const handleClickShowPassword = () => {
    setShowPassword((prev) => !prev);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };




  let checkLogedIn = () => {
    if (authToken) {
      navigate("/");
    } else {
      console.error("Unable to check authToken");
      return false;
    }
  };
  // checkLogedIn();

  useEffect(() => {
    checkLogedIn();
  }, []);
  return (
    <div className="login-page">
      <div className="login-decoration login-decoration-one" />
      <div className="login-decoration login-decoration-two" />
      <form onSubmit={loginUser}>
        <div className="login-shell">
          <section className="login-brand-panel">
            <div className="login-brand-mark"><img src="./assets/img/logo/PIC_Logo.svg" alt="P. Chandra Investment Co" /></div>
            <Typography variant="overline">P. Chandra Investment Co</Typography>
            <Typography className="login-brand-title">Your money.<br />Managed with clarity.</Typography>
            <Typography className="login-brand-copy">A secure operations workspace for investments, subscriptions, transactions and customer care.</Typography>
            <div className="login-security-note"><ShieldOutlined /> Enterprise-grade access for authorised administrators</div>
          </section>
          <section className="login-form-panel">
            <div className="login-form-heading">
              <Typography component="h1" variant="h4">Welcome back</Typography>
              <Typography>Sign in to continue to your workspace.</Typography>
            </div>
            <TextField
              margin="normal"
              required
              fullWidth
              name="username"
              label="Phone number"
              autoComplete="username"
            ></TextField>
             
            <TextField
              margin="normal"
              required
              fullWidth
              name="password"
              label="Password"
              autoComplete="current-password"
              type={showPassword ? "text" : "password"}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                      edge="end"
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            ></TextField>
            <Button
              variant="contained"
              color="primary"
              fullWidth
              type="Submit"
              name="submit"
              className="login-submit"
              endIcon={<ArrowForward />}
            >
              Sign in
            </Button>
            <Typography className="login-help">Need access help? Contact your system administrator.</Typography>
          </section>
        </div>
      </form>
    </div>
  );
};

export default LoginPage;
